import { PeakScoreLog } from "../types/post";

type LoadBalanceLog = Pick<
  PeakScoreLog,
  "workloadFactor" | "workloadFactorDisplay" | "loadBalanceProvisional"
> | null | undefined;

/**
 * Factor to show as Load Balance. A provisional cold-start day is held at 1
 * so the peak score stays neutral; that 1 is not a measured 0%.
 * Prefers the wider display factor used by the training-load UI.
 */
export function displayWorkloadFactor(log: LoadBalanceLog): number | undefined {
  if (!log || log.loadBalanceProvisional) return undefined;
  const value = log.workloadFactorDisplay ?? log.workloadFactor;
  if (typeof value !== "number" || !Number.isFinite(value)) return undefined;
  return value;
}

/**
 * Capped factor for the peak-score chart. Provisional days come back as 0 so
 * existing `> 0` filters leave the point off the line.
 */
export function recordedWorkloadFactor(log: LoadBalanceLog): number {
  if (!log || log.loadBalanceProvisional) return 0;
  const value = log.workloadFactor;
  return typeof value === "number" && Number.isFinite(value) && value > 0
    ? value
    : 0;
}

/** Mean of recorded factors, skipping provisional days. */
export function averageRecordedWorkload(logs: LoadBalanceLog[]): number {
  const values = logs
    .map((log) => recordedWorkloadFactor(log))
    .filter((value) => value > 0);
  if (values.length === 0) return 0;
  return values.reduce((sum, value) => sum + value, 0) / values.length;
}
